import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const DeliveryAddressFooterText = styled.p`
  font-family: ${props => props.theme.fonts.circular} !important;
  color: ${props => props.theme.colors.capsuleGray50} !important;
  font-size: ${props => props.theme.fontSizes.body} !important;
  font-weight: ${props => props.theme.fontWeights.book} !important;
  padding: 0 ${props => props.theme.space['1.0']} !important;
  margin-top: ${props => props.theme.space['1.0']} !important;

  letter-spacing: ${props => props.theme.letterSpacings.one} !important;
`;

export const StyledLink = styled(Link)`
  color: ${props => props.theme.colors.capsuleGreen60} !important;
`;
